<script setup lang="ts">
import { computed } from 'vue';
import { useQrCode } from '../model/useQrCode';

export type Props = {
    value: string;
    alt?: string;
    size?: number;
};

const props = withDefaults(defineProps<Props>(), {
    alt: 'QRコード',
    size: 200,
});

const valueRef = computed(() => props.value);
const { qrCodeDataUrl, isGenerating, errorMessage, generate } = useQrCode(valueRef);
</script>

<template>
    <div class="qr-code-container">
        <!-- ローディング -->
        <div v-if="isGenerating" class="qr-code-loading">
            <v-progress-circular indeterminate color="primary" size="32" />
        </div>

        <!-- QRコード画像 -->
        <img
            v-else-if="qrCodeDataUrl && !errorMessage"
            :src="qrCodeDataUrl"
            :alt="alt"
            :width="size"
            :height="size"
            class="qr-code-image"
        />

        <!-- エラー -->
        <div v-else-if="errorMessage" class="qr-code-error">
            <v-icon size="48" color="error">mdi-qrcode-remove</v-icon>
            <p class="text-body-2 text-error mt-2">{{ errorMessage }}</p>
            <v-btn color="primary" variant="outlined" size="small" class="mt-2" @click="generate(value)">
                再生成
            </v-btn>
        </div>

        <!-- 値なし -->
        <div v-else class="qr-code-empty">
            <v-icon size="48" color="grey">mdi-qrcode</v-icon>
        </div>
    </div>
</template>

<style scoped>
.qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.qr-code-image {
    border-radius: 8px;
}

.qr-code-loading,
.qr-code-error,
.qr-code-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
}
</style>
